import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.string.repeat";
import "core-js/modules/es6.array.sort";
import _defineProperty from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SmsOption from "./components/SmsOption.vue";
import Inbox from "./components/Inbox.vue";
import Outbox from "./components/Outbox.vue";
import Advanced from "./components/Advanced.vue";
import { listConfig, updateConfig, getLog } from "@/api/configurationlist";
export default {
  name: "",
  components: {
    SmsOption: SmsOption,
    Inbox: Inbox,
    Outbox: Outbox,
    Advanced: Advanced
  },
  props: ['deviceSn', 'deviceDid'],
  data: function data() {
    return {
      tabName: "0",
      //0=>配置，1=>收件箱,2=>发件箱,3=>高级
      loading: true,
      outboxMask: "",
      overMask: "",
      hardware_class: "",
      inboxMask: ""
    };
  },
  methods: {
    // 获取配置
    getConfig: function () {
      var _getConfig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var res, options, inboxStatus, inboxList, outboxStatus, outboxList, serviceOptions, inboxMask0, inboxMask1, inboxMask2, inboxMask3, inboxMask4, inboxMask5, inboxMask6, inboxMask7, outBefore, outAfter;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return listConfig(this.deviceSn, this.deviceDid, [{
                  config: "smartsms",
                  section: "setting",
                  options: [{
                    option: 'modem'
                  }, {
                    option: 'phone1'
                  }, {
                    option: 'memory'
                  }, {
                    option: 'center'
                  }, {
                    option: 'validity'
                  }, {
                    option: 'interval'
                  }, {
                    option: 'del_up_thr'
                  }, {
                    option: 'automatic_del'
                  }, {
                    option: 'del_low_thr'
                  }, {
                    option: 'delinterval'
                  }],
                  lists: [{
                    list: 'whitelist'
                  }]
                }, {
                  config: "inbox",
                  section: "status",
                  options: [{
                    option: "total"
                  }, {
                    option: "used"
                  }, {
                    option: "simcard"
                  }, {
                    option: "mask0"
                  }, {
                    option: "mask1"
                  }, {
                    option: "mask2"
                  }, {
                    option: "mask3"
                  }, {
                    option: "mask4"
                  }, {
                    option: "mask5"
                  }, {
                    option: "mask6"
                  }, {
                    option: "mask7"
                  }]
                }, {
                  config: "inbox",
                  section: "msg",
                  options: [{
                    option: "index"
                  }, {
                    option: "phone"
                  }, {
                    option: "content"
                  }, {
                    option: "date"
                  }, {
                    option: "state"
                  }, {
                    option: "merged"
                  }]
                }, {
                  config: "outbox",
                  section: "status",
                  options: [{
                    option: "total"
                  }, {
                    option: "mask0"
                  }, {
                    option: "mask1"
                  }]
                }, {
                  config: "outbox",
                  section: "msg",
                  options: [{
                    option: "index"
                  }, {
                    option: "phone"
                  }, {
                    option: "content"
                  }, {
                    option: "date"
                  }, {
                    option: "state"
                  }]
                }, {
                  config: "smartsms",
                  section: "service",
                  options: [{
                    option: 'enabled'
                  }, {
                    option: 'enable_debug'
                  }, {
                    option: 'log_file_num'
                  }, {
                    option: 'log_file_size'
                  }, {
                    option: 'log_priority'
                  }]
                }, {
                  config: "ciot",
                  section: 'system',
                  options: [{
                    option: "hardware_class"
                  }]
                }]);

              case 2:
                res = _context.sent;

                if (res.data.code === 0) {
                  options = res.data.data.mess[0].s_objects;
                  inboxStatus = res.data.data.mess[1].s_objects;
                  inboxList = res.data.data.mess[2].s_objects;
                  outboxStatus = res.data.data.mess[3].s_objects;
                  outboxList = res.data.data.mess[4].s_objects;
                  serviceOptions = res.data.data.mess[5].s_objects;
                  this.hardware_class = res.data.data.mess[6].s_objects[0].options.hardware_class;

                  if (options[0].lists.whitelist.length === 0) {
                    options[0].lists.whitelist.push('');
                  }

                  options[0].options.whitelist = options[0].lists.whitelist;
                  options[0].options.automatic_del === '1' ? options[0].options.automatic_del = true : options[0].options.automatic_del = false;
                  this.$refs['option'].option = options[0].options;
                  inboxList = inboxList.map(function (item) {
                    return item.options;
                  });
                  this.$refs['inbox'].total = inboxStatus[0].options.total;
                  this.$refs['inbox'].used = inboxStatus[0].options.used;
                  this.$refs['inbox'].simcard = inboxStatus[0].options.simcard;
                  this.$refs['inbox'].list = inboxList;
                  inboxMask0 = Number(inboxStatus[0].options.mask0).toString(2).split('').reverse().join('');
                  inboxMask1 = Number(inboxStatus[0].options.mask1).toString(2).split('').reverse().join('');
                  inboxMask2 = Number(inboxStatus[0].options.mask2).toString(2).split('').reverse().join('');
                  inboxMask3 = Number(inboxStatus[0].options.mask3).toString(2).split('').reverse().join('');
                  inboxMask4 = Number(inboxStatus[0].options.mask4).toString(2).split('').reverse().join('');
                  inboxMask5 = Number(inboxStatus[0].options.mask5).toString(2).split('').reverse().join('');
                  inboxMask6 = Number(inboxStatus[0].options.mask6).toString(2).split('').reverse().join('');
                  inboxMask7 = Number(inboxStatus[0].options.mask7).toString(2).split('').reverse().join('');
                  inboxMask0 = this.addZero(inboxMask0);
                  inboxMask1 = this.addZero(inboxMask1);
                  inboxMask2 = this.addZero(inboxMask2);
                  inboxMask3 = this.addZero(inboxMask3);
                  inboxMask4 = this.addZero(inboxMask4);
                  inboxMask5 = this.addZero(inboxMask5);
                  inboxMask6 = this.addZero(inboxMask6);
                  inboxMask7 = this.addZero(inboxMask7);
                  this.inboxMask = inboxMask0 + inboxMask1 + inboxMask2 + inboxMask3 + inboxMask4 + inboxMask5 + inboxMask6 + inboxMask7;
                  outboxList = outboxList.map(function (item) {
                    return _objectSpread(_objectSpread({}, item.options), {}, {
                      meta_index: item.index
                    });
                  });
                  this.$refs['outbox'].total = outboxStatus[0].options.total;
                  this.$refs['outbox'].used = outboxList.length;
                  outBefore = Number(outboxStatus[0].options.mask0).toString(2).split('').reverse().join('');
                  outAfter = Number(outboxStatus[0].options.mask1).toString(2).split('').reverse().join('');
                  outBefore = this.addZero(outBefore);
                  outAfter = this.addZero(outAfter);
                  this.outboxMask = outBefore + outAfter;
                  this.$refs['outbox'].list = outboxList.sort(function (a, b) {
                    return a.index - b.index;
                  }).map(function (item) {
                    return _objectSpread(_objectSpread({}, item), {}, {
                      mask: _this.outboxMask[item.index]
                    });
                  });
                  serviceOptions[0].options.enabled = serviceOptions[0].options.enabled === '1' ? true : false;
                  serviceOptions[0].options.enable_debug = serviceOptions[0].options.enable_debug === '1' ? true : false;
                  this.$refs['advanced'].options = serviceOptions[0].options;
                } else {
                  this.$message.error("获取失败");
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getConfig() {
        return _getConfig.apply(this, arguments);
      }

      return getConfig;
    }(),
    saveOption: function () {
      var _saveOption = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.loading = true;
                console.log(e);
                _context2.next = 4;
                return updateConfig(this.deviceSn, this.deviceDid, [{
                  config: "smartsms",
                  section: "setting",
                  action: 0,
                  index: [0],
                  options: e.options,
                  lists: e.lists
                }]).then(function (res) {});

              case 4:
                _context2.next = 6;
                return this.getConfig();

              case 6:
                this.loading = false;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function saveOption(_x) {
        return _saveOption.apply(this, arguments);
      }

      return saveOption;
    }(),
    // 补0方法
    addZero: function addZero(value) {
      if (value.length < 32) {
        value = value + '0'.repeat(32 - value.length);
      }

      return value;
    },
    removeInboxMsg: function () {
      var _removeInboxMsg = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e) {
        var inboxMask, inboxMask0, inboxMask1, inboxMask2, inboxMask3, inboxMask4, inboxMask5, inboxMask6, inboxMask7;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.loading = true;
                inboxMask = this.inboxMask.split('');
                inboxMask[e.index] = '0';
                inboxMask0 = parseInt(inboxMask.slice(0, 32).reverse().join(''), 2).toString();
                inboxMask1 = parseInt(inboxMask.slice(32, 64).reverse().join(''), 2).toString();
                inboxMask2 = parseInt(inboxMask.slice(64, 96).reverse().join(''), 2).toString();
                inboxMask3 = parseInt(inboxMask.slice(96, 128).reverse().join(''), 2).toString();
                inboxMask4 = parseInt(inboxMask.slice(128, 160).reverse().join(''), 2).toString();
                inboxMask5 = parseInt(inboxMask.slice(160, 192).reverse().join(''), 2).toString();
                inboxMask6 = parseInt(inboxMask.slice(192, 224).reverse().join(''), 2).toString();
                inboxMask7 = parseInt(inboxMask.slice(224, 256).reverse().join(''), 2).toString();
                _context3.next = 13;
                return updateConfig(this.deviceSn, this.deviceDid, [{
                  config: "inbox",
                  section: "msg",
                  action: 2,
                  index: [Number(e.iindex)]
                }, {
                  config: "inbox",
                  section: "status",
                  action: 0,
                  index: [0],
                  options: {
                    mask0: inboxMask0,
                    mask1: inboxMask1,
                    mask2: inboxMask2,
                    mask3: inboxMask3,
                    mask4: inboxMask4,
                    mask5: inboxMask5,
                    mask6: inboxMask6,
                    mask7: inboxMask7
                  }
                }]).then(function (res) {});

              case 13:
                _context3.next = 15;
                return this.getConfig();

              case 15:
                this.loading = false;

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function removeInboxMsg(_x2) {
        return _removeInboxMsg.apply(this, arguments);
      }

      return removeInboxMsg;
    }(),
    saveAsDraft: function () {
      var _saveAsDraft = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(e) {
        var _this2 = this;

        var new_index, _loop, i, _ret, m;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.loading = true;
                new_index = this.$refs['outbox'].list.length;

                if (!(e.index == "")) {
                  _context6.next = 19;
                  break;
                }

                _loop = function _loop(i) {
                  if (_this2.$refs['outbox'].list.find(function (v) {
                    return v.index == i;
                  })) {} else {
                    new_index = i;
                    return "break";
                  }
                };

                i = 0;

              case 5:
                if (!(i < 50)) {
                  _context6.next = 12;
                  break;
                }

                _ret = _loop(i);

                if (!(_ret === "break")) {
                  _context6.next = 9;
                  break;
                }

                return _context6.abrupt("break", 12);

              case 9:
                i++;
                _context6.next = 5;
                break;

              case 12:
                m = this.outboxMask.split('');

                if (e.state == 5) {
                  m[new_index] = '0';
                } else {
                  m[new_index] = '1';
                }

                this.outboxMask = m.join(''); // 新增

                _context6.next = 17;
                return updateConfig(this.deviceSn, this.deviceDid, [{
                  config: "outbox",
                  section: "msg",
                  sname: "id" + new_index,
                  action: 1,
                  index: [new_index],
                  options: {
                    phone: e.phone,
                    content: e.content,
                    date: Date.now().toString(),
                    state: e.state,
                    index: new_index
                  }
                }, {
                  config: "outbox",
                  section: "status",
                  action: 0,
                  index: [0],
                  options: {
                    mask0: parseInt(this.outboxMask.slice(0, 32).split('').reverse().join(''), 2).toString(),
                    // 取outboxMask的第32位到第63位，并且转为十进制
                    mask1: parseInt(this.outboxMask.slice(32, 64).split('').reverse().join(''), 2).toString()
                  }
                }]).then( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(res) {
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (res.data.data.mess === 0) {
                              _this2.$message.success("存为草稿成功");
                            } else {
                              _this2.$message.error("存为草稿失败");
                            }

                            _context4.next = 3;
                            return _this2.getConfig();

                          case 3:
                            _this2.loading = false;
                            _this2.$refs.outbox.editMsgDialog = false;

                          case 5:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x4) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 17:
                _context6.next = 25;
                break;

              case 19:
                _context6.next = 21;
                return updateConfig(this.deviceSn, this.deviceDid, [{
                  config: "outbox",
                  section: "msg",
                  action: 0,
                  index: [Number(e.index)],
                  options: {
                    phone: e.phone,
                    content: e.content,
                    date: Date.now().toString(),
                    state: e.state
                  }
                }]).then( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(res) {
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (res.data.data.mess === 0) {
                              _this2.$message.success("短信发送中");
                            } else {
                              _this2.$message.error("短信发送失败");
                            }

                            _context5.next = 3;
                            return _this2.getConfig();

                          case 3:
                            _this2.loading = false;
                            _this2.$refs.outbox.editMsgDialog = false;

                          case 5:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x5) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 21:
                _context6.next = 23;
                return this.getConfig();

              case 23:
                this.loading = false;
                this.$refs.outbox.editMsgDialog = false;

              case 25:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function saveAsDraft(_x3) {
        return _saveAsDraft.apply(this, arguments);
      }

      return saveAsDraft;
    }(),
    saveAdvanced: function () {
      var _saveAdvanced = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(e) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.loading = true;
                _context7.next = 3;
                return updateConfig(this.deviceSn, this.deviceDid, [{
                  config: "smartsms",
                  section: "service",
                  server: "smartsms",
                  action: 0,
                  index: [0],
                  options: e
                }]).then(function (res) {});

              case 3:
                _context7.next = 5;
                return this.getConfig();

              case 5:
                this.loading = false;

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function saveAdvanced(_x6) {
        return _saveAdvanced.apply(this, arguments);
      }

      return saveAdvanced;
    }(),
    deleteOutboxMsg: function () {
      var _deleteOutboxMsg = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(e) {
        var m;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                // 将this.outboxMask的第e.index位设置为0
                m = this.outboxMask.split('');
                m[e.index] = '0';
                this.outboxMask = m.join('');
                this.loading = true;
                _context8.next = 6;
                return updateConfig(this.deviceSn, this.deviceDid, [{
                  config: "outbox",
                  section: "msg",
                  action: 2,
                  index: [Number(e.iindex)]
                }, {
                  config: "outbox",
                  section: "status",
                  action: 0,
                  index: [0],
                  options: {
                    mask0: parseInt(this.outboxMask.slice(0, 32).split('').reverse().join(''), 2).toString(),
                    // 取outboxMask的第32位到第63位，并且转为十进制
                    mask1: parseInt(this.outboxMask.slice(32, 64).split('').reverse().join(''), 2).toString()
                  }
                }]).then(function (res) {});

              case 6:
                _context8.next = 8;
                return this.getConfig();

              case 8:
                this.loading = false;

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function deleteOutboxMsg(_x7) {
        return _deleteOutboxMsg.apply(this, arguments);
      }

      return deleteOutboxMsg;
    }(),
    downloadLog: function downloadLog() {
      var params = {
        did: this.deviceDid,
        sn: this.deviceSn,
        mess: "smartsms"
      };
      getLog(params).then(function (res) {
        var blob = new Blob([res.data], {
          type: 'application/octet-stream'
        });
        var fileName = 'log.txt';

        if ('download' in document.createElement('a')) {
          // 非IE下载
          var elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象

          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    sendSelectSms: function sendSelectSms(e) {
      var _this3 = this;

      var m = this.outboxMask.split('');
      m[e.index] = '1';
      this.outboxMask = m.join('');
      this.loading = true;
      updateConfig(this.deviceSn, this.deviceDid, [{
        config: "outbox",
        section: "msg",
        action: 0,
        index: [Number(e.iindex)],
        options: {
          state: "2"
        }
      }, {
        config: "outbox",
        section: "status",
        action: 0,
        index: [0],
        options: {
          mask0: parseInt(this.outboxMask.slice(0, 32).split('').reverse().join(''), 2).toString(),
          // 取outboxMask的第32位到第63位，并且转为十进制
          mask1: parseInt(this.outboxMask.slice(32, 64).split('').reverse().join(''), 2).toString()
        }
      }]).then(function (res) {
        if (res.data.data.mess === 0) {
          _this3.$message.success("短信发送中");

          _this3.loading = false;
          _this3.$refs.outbox.editMsgDialog = false;
        } else {
          _this3.$message.error("短信发送失败");

          _this3.loading = false;
          _this3.$refs.outbox.editMsgDialog = false;
        }
      });
    },
    refesh: function () {
      var _refesh = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.loading = true;
                _context9.next = 3;
                return this.getConfig();

              case 3:
                this.loading = false;

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function refesh() {
        return _refesh.apply(this, arguments);
      }

      return refesh;
    }()
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.getConfig();

            case 2:
              this.loading = false;

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }()
};